import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as QRCode from 'qrcode';
import { enviroment } from 'src/environments/environment';
import { ProjectService } from 'src/app/service/project.service';
import { UpdateProjectPutReq } from 'src/app/model/request/update-project-put-req';

@Component({
  selector: 'app-share-project-modal',
  templateUrl: './share-project-modal.component.html',
  styleUrls: ['./share-project-modal.component.css'],
})
export class ShareProjectModalComponent {
  @Input() projectId!: string;
  @Input() ownerUserId!: string;
  @Input() isOwner = false;
  @Input() set sharingTypeId(v: number) { this._sharingTypeId = v; this.refreshQr(); }
  get sharingTypeId(): number { return this._sharingTypeId; }
  private _sharingTypeId = 0;

  @Input() set visible(v: boolean) { this._visible = v; if (v) this.refreshQr(); }
  get visible(): boolean { return this._visible; }
  private _visible = false;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() sharingTypeChanged = new EventEmitter<number>();

  qrCodeDataUrl = '';
  updating = false;
  copied = false;
  private copiedTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private projectService: ProjectService) {}

  get shareUrl(): string {
    return this.projectId ? `${enviroment.BASE_URL}/feed/project/${this.projectId}` : '';
  }
  get isShareable(): boolean { return this._sharingTypeId === 1 || this._sharingTypeId === 2; }

  private async refreshQr(): Promise<void> {
    if (!this._visible || !this.isShareable || !this.projectId) return;
    try {
      this.qrCodeDataUrl = await QRCode.toDataURL(this.shareUrl, {
        width: 300, margin: 2, color: { dark: '#000000', light: '#FFFFFF' },
      });
    } catch { this.qrCodeDataUrl = ''; }
  }

  close(): void { this._visible = false; this.visibleChange.emit(false); }
  copyLink(): void {
    navigator.clipboard?.writeText(this.shareUrl);
    this.copied = true;
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
    this.copiedTimer = setTimeout(() => (this.copied = false), 2000);
  }

  shareOnFacebook(): void { window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`, '_blank'); }
  shareOnWhatsapp(): void { window.open(`https://wa.me/?text=${encodeURIComponent(this.shareUrl)}`, '_blank'); }
  shareOnThreads(): void { window.open(`https://www.threads.com/intent/post?url=${encodeURIComponent(this.shareUrl)}`, '_blank'); }
  shareOnTwitter(): void { window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(this.shareUrl)}`, '_blank'); }

  setVisibility(typeId: number): void {
    if (!this.isOwner || this.updating) return;
    this.updating = true;
    const body: UpdateProjectPutReq = { sharingProjectTypeID: typeId } as UpdateProjectPutReq;
    this.projectService.updateProject(this.ownerUserId, this.projectId, body).subscribe({
      next: () => { this.updating = false; this._sharingTypeId = typeId; this.sharingTypeChanged.emit(typeId); this.refreshQr(); },
      error: () => { this.updating = false; },
    });
  }
}
